import {CdAimEvaluationReason} from '../../../interfaces/care/cd-care-plan/cd-aim-evaluation-reason';

export class CdAimEvaluationReasonFactory {

  public static fromObject(cdEvaluationReason: any): CdAimEvaluationReason {
    return new class implements CdAimEvaluationReason {
      created: string = cdEvaluationReason.created;
      id: number = cdEvaluationReason.id;
      modified: string = cdEvaluationReason.modified;
      name: string = cdEvaluationReason.name;
      shortName: string = cdEvaluationReason.short_name;
      userId: number = cdEvaluationReason.user_id;
    };
  }

  public static fromArray(cdEvaluationReasons: any[]): CdAimEvaluationReason[] {
    return cdEvaluationReasons.map(cdEvaluationReason => this.fromObject(cdEvaluationReason));
  }

}
